// extracted by mini-css-extract-plugin
export default {"productGallery":"TI-z","inQuickShop":"UI-z"};